import { useQuery } from "@tanstack/react-query"
import { websiteProductService } from "@/api/websiteProductService"

export const useWebsiteProduct = (sku: string) => {
  return useQuery({
    queryKey: ["website-product", sku],
    queryFn: ({ signal }) => websiteProductService.getProductGroup(sku, signal),
    enabled: !!sku,
  })
}
